// @todo Why not make it index.ts?
import { combineReducers, createSelector } from '@reduxjs/toolkit';
import { compose, keyBy, mapValues } from 'lodash/fp';
import { StateType } from 'typesafe-actions';

import {
    AgeGroupEntity,
    AgeGroupsOrder,
    CountryLocationSdi,
    DataProject,
    SmartOptionResource,
} from '@portal/common/types';

import data from './data/reducer';
import entityHierarchies from './entity-hierarchies/reducer';
import insights from './insights/reducer';
import sessionError from './session/error-reducer';
import session from './session/reducer';
import { SESSION_SIGNED_OUT } from './session/types';

const rootReducer = combineReducers({
    data,
    session,
    sessionError,
    entityHierarchies,
    insights,
});

export type RootState = StateType<typeof rootReducer>;

export default (prevState: RootState, action: any) => {
    switch (action.type) {
        // clean root state on sign out
        case SESSION_SIGNED_OUT:
            return rootReducer(undefined, action);

        default:
            return rootReducer(prevState, action);
    }
};

// session selectors
export const getSessionAccount = (state: RootState) => state.session.account;
export const getSessionAccountId = (state: RootState) =>
    state.session.account && state.session.account.id;
export const getSessionError = (state: RootState) => state.sessionError;

export const getCategories = (state: RootState) => state.data.categories;
export const getOrganizations = (state: RootState) => state.data.organizations;
export const getDatasets = (state: RootState) => state.data.datasets;
export const getDataProjects = (state: RootState) => state.data.dataProjects;
export const getDataCollectionNamesById = (state: RootState): Record<number, string> =>
    state.data.dataCollectionNamesById;
export const getIsRequiredDataLoaded = (state: RootState): boolean =>
    state.data.isRequiredDataLoaded;
export const getDataProjectNameById = (dataProjects: DataProject[], id: number) =>
    (dataProjects || []).find((i) => i.id === +id)?.name || '';

export const getAgeGroups = (state: RootState): AgeGroupEntity[] | null => state.data.ageGroups;

export const getAgeGroupsOrder = createSelector(
    getAgeGroups,
    (ageGroups): AgeGroupsOrder | null => {
        if (ageGroups == null) {
            return null;
        }

        return compose(mapValues('order'), keyBy('id'))(ageGroups) as AgeGroupsOrder;
    }
);
export const getCountryLocationSdi = (state: RootState): CountryLocationSdi[] | null =>
    state.data.countryLocationSdi;
export const getSmartOptions = (state: RootState): SmartOptionResource[] | null =>
    state.data.smartOptions;
